module.exports = __webpack_public_path__ + "img/chevron-down3.29711a89.svg";